import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { FINANCIAL_TYPES } from "../../../../constants/financial";

/**
 * FinancialCategorySidebar
 * Lista de categorias financeiras utilizando o NeoSideMenu do Neo Design System.
 */
const FinancialCategorySidebar = ({ categories = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar categorias baseado na pesquisa local
    const filteredCategories = categories.filter((category) =>
        category.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear categorias para o formato padrão do NeoSideMenu
    const sideMenuItems = filteredCategories.map((category) => ({
        id: category.id,
        label: category.name,
        description: category.dreOrder ? `Ordem DRE: ${category.dreOrder}` : "Sem ordem DRE",
        badge: category.type === FINANCIAL_TYPES.INCOME ? "Receita" : "Despesa",
        badgeVariant: category.type === FINANCIAL_TYPES.INCOME ? "success" : "danger",
        icon: category.type === FINANCIAL_TYPES.INCOME ? "mdi-trending-up" : "mdi-trending-down"
    }));

    return (
        <NeoSideMenu
            title="Categorias"
            subtitle="Plano de Contas (DRE)"
            icon="mdi-tag-multiple-outline"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const category = categories.find((cat) => cat.id === id);
                if (category) onSelect(category);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar categoria..."
                />
            }
        />
    );
};

FinancialCategorySidebar.propTypes = {
    categories: PropTypes.array,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default FinancialCategorySidebar;
